export enum TimeUnit {
  HOUR_24,
  HOUR_12,
  MINUTE,
}

export const minMaxTimeUnit: Record<TimeUnit, { min: number; max: number }> = {
  [TimeUnit.HOUR_12]: {
    min: 1,
    max: 12,
  },
  [TimeUnit.HOUR_24]: {
    min: 0,
    max: 23,
  },
  [TimeUnit.MINUTE]: {
    min: 0,
    max: 59,
  },
}

export function getPmFrom24Hour(hour: number) {
  if (hour < 0 || hour > 23) {
    throw new Error(`hour must be between [0,23] inclusive: got ${hour}`)
  }
  return hour >= 12
}

export function isValidTimeUnit(unit: TimeUnit, value: number) {
  return (
    value !== null &&
    !isNaN(value) &&
    minMaxTimeUnit[unit].min <= value &&
    value <= minMaxTimeUnit[unit].max
  )
}
